// @flow
import * as React from 'react';
import {
  TextField,
  Box,
  // $FlowFixMe
} from '@mui/material';

import FieldContainer from 'Components/FieldContainer';

// $FlowFixMe
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

import { Controller } from 'react-hook-form';

import { CABLING_TYPES } from 'Constants/installationAsBuild';

import RadioWithOtherField from './RadioWithOtherField';

type Props = {|
  errors: Object,
  control: Object,
  setValue: Function,
|};

function Step2(props: Props): React.Node {
  const { errors, control, setValue } = props;

  return (
    <Box>
      <FieldContainer
        htmlFor="numberOfUnits"
        label="Build Summary Number of units"
        error={errors.numberOfUnits}
      >
        <Controller
          name="numberOfUnits"
          control={control}
          render={({ field }) => (
            <TextField {...field} variant="outlined" fullWidth />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="cablingType"
        label="Cabling Type"
        error={errors.cablingType}
      >
        <RadioWithOtherField
          name="cablingType"
          control={control}
          setValue={setValue}
          options={CABLING_TYPES}
          errors={errors}
          otherPlaceholder="Enter cabling type"
          otherMultiline
          otherRows={4}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="leadEngineerForBuild"
        label="Lead Engineer For Build"
        error={errors.leadEngineerForBuild}
      >
        <Controller
          name="leadEngineerForBuild"
          control={control}
          render={({ field }) => (
            <TextField {...field} variant="outlined" fullWidth />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="endDateOfStageOneCablingWork"
        label="End Date of Stage One Cabling Work"
        error={errors.endDateOfStageOneCablingWork}
      >
        <Controller
          name="endDateOfStageOneCablingWork"
          control={control}
          defaultValue=""
          render={({ field: { ref, ...rest } }) => (
            <MobileDatePicker
              id="endDateOfStageOneCablingWork-dialog"
              inputFormat="MM/DD/YYYY"
              renderInput={(params) => <TextField {...params} fullWidth />}
              {...rest}
            />
          )}
        />
      </FieldContainer>
    </Box>
  );
}

export default Step2;
